import React from 'react';
import { useTranslation } from 'next-i18next';
import Dialog from '@components/atoms/dialog/dialog';
import Button from '@components/atoms/button/button';
import styles from '../alerts-create-manage-section/alerts-create-manage-section.module.scss';

export type SuccessModalProps = {
  open: boolean;
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
} & React.HTMLProps<HTMLDivElement>;

const SuccessModal: React.FC<SuccessModalProps> = (props): React.JSX.Element => {
  const { open: openAlertsModal, handleClose } = props;

  const { t } = useTranslation();

  const handleCloseDialog = (isOpened) => {
    handleClose(isOpened);
  };

  return (
    <Dialog
      closeDialog={handleCloseDialog}
      key={`openAlertsModal${openAlertsModal}`}
      isOpen={openAlertsModal}
      dataCyIdentifierForContainer="alert_creation_success_modal"
      hasCloseIcon
      styles={{
        content: {
          maxWidth: '600px',
        },
      }}
    >
      <div
        className="vc-modal__title"
        data-cy="alert_creation_success_modal_title"
      >
        {t('ALERT.SUCCESSMODAL.TITLE')}
      </div>
      <div
        className="vc-modal__content"
        data-cy="alert_creation_success_modal_content"
      >
        <p className="intro">{t('ALERT.SUCCESSMODAL.NOTIF_REDIRECTION')}</p>
        <div className={styles.actionContainer}>
          <Button
            variant="primary"
            size="medium"
            onClick={handleCloseDialog}
            data-cy="alert_creation_success_modal_btn"
          >
            {t('ALERT.MODAL.BTN_CREATE')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default SuccessModal;
